<template>
  <div class="nav-wrap">
    <div class="company">
      <img
        v-if="!noFold"
        :class="[isActive ? 'is_active' : '']"
        src="https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mapp/emi/icon_fold.png"
        @click="toggle"
      />
      <span>{{ shortName }}</span>
    </div>

    <el-popover placement="bottom" width="160" trigger="hover">
      <div class="btn-wrap">
        <div @click.stop="accountSetting">
          <img
            class="icon_avatar"
            src="https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mapp/emi/icon_account_setting.png"
          />
          <span>账号设置</span>
        </div>
        <div @click.stop="logout">
          <img
            class="icon_avatar"
            src="https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mapp/emi/icon_logout.png"
          />
          <span>退出登录</span>
        </div>
      </div>
      <div slot="reference" class="account">
        <img
          class="icon_avatar"
          src="https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mapp/emi/icon_avatar.png"
        />
        <span>{{ userInfo.loginName }}</span>
        <img
          class="icon_logout"
          src="https://xlian-oss-pro-public.oss-cn-hangzhou.aliyuncs.com/mapp/emi/icon_arrow_down.png"
        />
      </div>
    </el-popover>
  </div>
</template>

<script>
import store from '@/store'
import { mapGetters } from 'vuex'
export default {
  props: {
    noFold: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      isActive: false
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    shortName() {
      return this.userInfo?.companyInfo?.shortName
    }
  },
  methods: {
    toggle() {
      this.isActive = !this.isActive
      this.$emit('active', this.isActive)
    },
    async logout() {
      await this.$api.loginOut({
        accountCode: this.userInfo.accountCode,
        platform: 'emi'
      })
      store.dispatch('user/resetToken')
      this.$router.push({
        path: '/login'
      })
    },
    accountSetting() {
      this.$router.push({
        path: '/account'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.is_active {
  transform: rotate(180deg);
}
.nav-wrap {
  height: 52px;
  background: #fff;
  display: flex;
  justify-content: space-between;
  // width: 100vh;
  width: 100%;
  align-items: center;
  padding: 0 24px;
  .account {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    cursor: pointer;
    > span {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 22px;
      padding: 0 8px;
    }
    .icon_avatar {
      width: 24px;
      height: 24px;
      display: inline-block;
    }
    .icon_logout {
      width: 12px;
      height: 12px;
      display: inline-block;
    }
  }
  .company {
    display: flex;
    align-items: center;
    > img {
      width: 24px;
      height: 24px;
      display: inline-block;
      cursor: pointer;
      margin-right: 12px;
      box-sizing: border-box;
    }
    > span {
      height: 28px;
      font-size: 16px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 600;
      color: #1d2129;
      line-height: 28px;
    }
  }
}
.btn-wrap {
  display: flex;
  flex-direction: column;
  > div {
    height: 46px;
    // width: 160px;
    box-sizing: border-box;
    padding: 4px;
    display: flex;
    align-items: center;
    > span {
      font-size: 14px;
      font-family: PingFang SC, PingFang SC;
      font-weight: 400;
      color: #1d2129;
      line-height: 22px;
      padding-left: 8px;
      -webkit-user-select: none; /* Safari */
      -ms-user-select: none; /* IE 10 and IE 11 */
      user-select: none; /* Standard syntax */
    }
    > img {
      display: inline-block;
      width: 20px;
      height: 20px;
      margin-left: 8px;
    }
    &:hover {
      background: #f5f7fa;
    }
  }
}
</style>
